import React, { Component } from 'react';
import OLVectorLayer from 'ol/layer/vector';

class VectorLayer extends Component {
  constructor(props) {
    super(props);

    this.vectorLayer = new OLVectorLayer({
      style: props.style || undefined,
      visible: true,
      // we are probably running into this issue when having rendermode `image`:
      // https://github.com/openlayers/openlayers/issues/7954
      // (texel is really slow and unrespronsive, probably because of the many layers)
      renderMode: props.rendermode || 'canvas',
    });
  }

  componentDidUpdate(oldProps) {
    //if(oldProps.style !== this.props.style){ << then, when should we do this?
      this.vectorLayer.setStyle(this.props.style);
    //}

    this.vectorLayer.setZIndex(this.props.zIndex);
    this.vectorLayer.setVisible(this.props.visible);
  }

  componentDidMount() {
    this.props.mapInstance.addLayer(this.vectorLayer);
  }

  componentWillUnmount() {
    this.props.mapInstance.removeLayer(this.vectorLayer);
  }

  render() {
    return React.cloneElement(this.props.children, { vectorLayer: this.vectorLayer })
  }
}

export default VectorLayer;



// WEBPACK FOOTER //
// ./src/components/ol/VectorLayer.js